<template>
    <div>
        <section id="demo" class="demo observer-fade">
            <div class="container">
                <div class="demo-container two-col">
                    <div class="demo-content linked">
                        <h2>Ideal usecases</h2>
                        <p>
                            <strong>Stay on top of fast approaching deadlines</strong>. Free up your brain to focus on other important aspects of your work. Our custom reminders are designed to cover a wide range of your needs as a freelancer or digital influencer.
                        </p>
                        <ul class="demo-features">
                            <li v-for="item in remindersList" :key="item">
                                <span class="check-icon">✓</span>{{ item }}
                            </li>
                        </ul>
                    </div>

                    <div class="demo-visual">
                        <div class="invoice-preview up grid gap-4 bg-none shadow-none">
                            <div v-for="item in remindersImg" :key="item" class="white-card shadow-md">
                                <div class="icon reminders" :class="[item.iconName]">
                                    {{ item.icon }}
                                </div>
                                <div class="flex-1 text-wrap">
                                    <p class="text-gray-800 mb--0 text--semi--bold">
                                        {{ item.text }}
                                    </p>
                                    <p class="text-gray-600 mb--0 mt--3">
                                        {{ item.desc }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="demo" class="demo observer-fade">
            <div class="container">
                <div class="demo-container two-col split bg-none">
                    <div class="demo-visual flex bg-g-three p-2">
                        <div class="problem-card steps grid gap-4 bg-transparent border-0 shadow-none">
                            <div v-for="item in clientCheckIns" :key="item.title" class="white-card shadow-md">
                                <div class="icon reminders money">
                                    {{ item.icon }}
                                </div>
                                <div class="flex-1 text-wrap">
                                    <p class="feature-title mb--0 text--sm">
                                        {{ item.title }}
                                    </p>
                                    <p class="feature-description mb--0 mt--3 text--sm">
                                        {{ item.desc }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="demo-content right-line">
                        <h2>Useful for client checkins</h2> 
                        <p>
                            <strong>Worry less about struggling to remember upcoming check-ins </strong>. Schedule automated check-ins with active clients in less than two clicks. Or just opt-out for email reminders to send the email yourself.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- <section id="demo" class="demo observer-fade">
            <div class="container">
                <div class="demo-container two-col bg-none">
                    <div class="demo-visual bg-transparent gap-3 grid">
                        <div v-for="item in filterItems" :key="item.title" class="demo-visual-filter">
                            <div class="flex">
                                <span class="mr--10 text-gray-600">{{ item.title }}:</span>
                                <span class="badge rounded-pill bg-light text-dark">{{ item.filter }}</span>
                            </div>
                            <span class="badge rounded-pill bg-light text-dark">{{ item.query }}</span>
                            <div class="ml--20">
                                <IconSvg name="x" fill="#6b7280" /> 
                            </div>
                        </div>
                    </div>

                    <div class="demo-content right-line">
                        <h2>Stay on top of crucial things</h2> 
                        <p>
                            <strong>Get reminders </strong>on priority tasks and projects. Schedule reminder periods. Organize and priortize the most important aspects of your business.
                        </p>
                    </div>
                </div>
            </div>
        </section> -->

        <section id="demo" class="demo observer-fade">
            <div class="container">
                <div class="demo-container split two-col bg-none">
                    <div class="demo-content line">
                        <h2>Focus on what matters</h2>
                        <p>
                            <strong>Forget chasing clients for unpaid or partially paid invoices</strong>. Set automated reminders and leave us to handle the expected follow-ups.
                        </p>
                    </div>

                    <div class="demo-visual grid gap-3">
                        <div v-for="(item, index) in invoiceReminders" :key="index" class="invoice-preview linked p-3 align-items-center flex">
                            <div class="icon reminders money flex align-items-center mr--10">
                                <template v-if="index === (invoiceReminders.length - 1)">
                                    <span class="text--lg">✅</span>
                                </template>
                                <template v-else>
                                    <span class="text--lg">⏰</span>
                                </template>
                            </div>
                            <div class="">
                                <span class="feature-title text--sm">{{ item.name }}</span>
                                <p class="feature-description text--xs mb--0">
                                    {{ index === (invoiceReminders.length - 1) ? 'Due date:' : 'Reminder date:' }} {{ item.date }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { remindersImg, mapReminders } from "@/utils/dummy";
import { getDateFromEnum } from "@/utils/date";

export default {
    name: "ProductReminders",

    data() {
        return {
            remindersImg,
            remindersList: [
                "Client check-ins",
                "Project deadlines",
                "Due tasks",
                "Unpaid or partially paid invoices",
                "Scheduled projects",
            ],
            clientCheckIns: [
                { icon: "➕ ", title: "Open a new check-in event", desc: "Start a check-in event." },
                { icon: "📱", title: "Select a category", desc: "Check-in category such as, a follow-up or sales pitch email." },
                { icon: "📅", title: "Set a check-in time", desc: "Pick a time to send email to clients on your behalf." },
                { icon: "✅", title: "Check-in event created", desc: "You get a reminder notification or we send a scheduled email to your client for you." },
            ],
            mapReminders,
            observer: null,
        };
    },

    computed: {
        invoiceReminders() {  
            const reminders = ["1_day_before", "7_days_before", "Current date"];          
            
            return reminders.map(x => {
                if (["7_days_before", "1_day_before"].includes(x)) {

                    return {
                        name: this.mapReminders[x],
                        date: this.$format_date(this.getDateFromEnum(x)),
                    };
                } else {
                    return {
                        name: "Invoice sent",
                        date: new Date().toDateString(),
                    };
                }
            });
        },
    },

    async mounted() {
        this.initPageIntersectionObserver();
    },
    
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    
    methods: {
        getDateFromEnum,
        initPageIntersectionObserver() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: "0px 0px -50px 0px",
            });

            // Observe all elements with observer-fade class
            document.querySelectorAll(".observer-fade").forEach(el => {                
                this.observer.observe(el);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    @media (max-width: 768px) {
        .hero h1 {
            font-size: 2.5rem;
        }

        .features-grid {
            grid-template-columns: 1fr;
        }

        .container {
            padding: 0 1rem;
        }
    }

    .white-card .icon {
        font-size: 15px;
        width: 35px;
        height: 35px;
        border-radius: 8px;
    }
</style>